import { NavLink } from "react-router-dom";
import { useAuth } from "@/lib/auth.jsx";

const ITEMS = [
  { to: "/reports/pipeline", label: "Pipeline Dashboard", active: true, testid: "sub-nav-pipeline-dashboard" },
  { to: "/reports/aging", label: "Deal Aging", active: true, testid: "sub-nav-aging" },
  { to: "/reports/agents", label: "Agent Run Analytics", active: true, roles: ["vc_admin", "senior_vc"], testid: "sub-nav-agents" },
  { to: "/reports/ai-usage", label: "AI Token Usage", active: true, testid: "sub-nav-ai-usage" },
  { to: "/reports/custom", label: "Custom Reports", active: true, roles: ["vc_admin", "senior_vc"], testid: "sub-nav-custom" },
  { to: "/reports/email-reports", label: "Email Reports", active: true, roles: ["vc_admin", "senior_vc"], testid: "sub-nav-email-reports" },
];

export default function ReportsSubNav() {
  const { user } = useAuth();
  const items = ITEMS.filter((i) => !i.roles || i.roles.includes(user?.role));
  return (
    <div className="border-b flex gap-1 overflow-x-auto" style={{ borderColor: "var(--cw-border)" }}
      data-testid="reports-sub-nav">
      {items.map((it) => (
        <NavLink key={it.to} to={it.to}
          className={({ isActive }) =>
            `px-4 py-2 text-sm font-medium border-b-2 -mb-px transition whitespace-nowrap ${
              isActive ? "" : "text-[var(--cw-muted)] border-transparent"
            }`
          }
          style={({ isActive }) =>
            isActive
              ? { color: "var(--cw-primary)", borderColor: "var(--cw-secondary)" }
              : {}
          }
          data-testid={it.testid}
        >
          {it.label}
          {!it.active && (
            <span className="ml-2 text-[10px] cw-caption uppercase">Soon</span>
          )}
        </NavLink>
      ))}
    </div>
  );
}
